export const RADIO_GROUP_ITEMS_PER_COLUMN = 4;
export const RADIO_GROUP_ITEM_KINDS = {
    Default: 'default',
    Compact: 'compact',
};
